import { Button } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import Chip from "components/Chip";
import TableComponent from "components/TableComponent";
import { Colors } from "constants/colors";
import { Dispatch, SetStateAction } from "react";
import { useNavigate } from "react-router-dom";
import { PLAN_TYPE } from "utils/enums";

type props = {
  rows: any;
  count: number;
  page?: any;
  onPageChange?: any;
  loading?: any;
  onCancel?: any;
};

const IndividualSubscriptions = ({
  rows,
  count,
  page,
  onPageChange,
  loading,
  onCancel,
}: props) => {
  const navigate = useNavigate();
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const columns: GridColDef[] = [
    {
      flex: 0.4,
      minWidth: 200,
      field: "user",
      headerName: "Plan name",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            {/* <figure
              onClick={() => navigate(`/profile-detail/individual/${row?._id}`)}
            >
              <img src={"/static/images/user_placeholder.png"} alt="" />
            </figure> */}
            <p>
              <b>{row?.planName || ''}</b>

            </p>
          </div>
        );
      },
    },

    {
      flex: 0.4,
      minWidth: 100,
      field: "type",
      headerName: "Subscription Type",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.planDuration ? PLAN_TYPE[row?.planDuration] : "N/A"}</p>
          </div>
        );
      },
    },
    {
      flex: 0.4,
      minWidth: 100,
      field: "status",
      headerName: "Status",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <Chip
              label={row?.isActive ? "Active" : "Inactive"}
              backgroundColor={Colors.primary}
              color="white"
            />
          </div>
        );
      },
    },

    {
      flex: 0.4,
      minWidth: 100,
      field: "paymentStatus",
      headerName: "payment Status",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <Chip label="Paid" backgroundColor={Colors.primary} color="white" />
          </div>
        );
      },
    },
    {
      flex: 0.4,
      minWidth: 100,
      field: "amount",
      headerName: "Amount",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>$ {row?.planAmount || 0}</p>
          </div>
        );
      },
    },
    // {
    //   flex: 0.4,
    //   minWidth: 100,
    //   field: "vehicles",
    //   headerName: "Vehicles",
    //   editable: false,
    //   sortable: false,
    //   renderCell: ({ row }) => {
    //     return (
    //       <div className="user_block" style={{ gap: 8 }}>
    //         <figure
    //           style={{ borderRadius: 0, minWidth: 30, height: 20, width: 30 }}
    //         >
    //           <img src={"/static/images/car.png"} alt="" />
    //         </figure>
    //         <p>2</p>
    //       </div>
    //     );
    //   },
    // },
    // {
    //   flex: 0.4,
    //   minWidth: 100,
    //   field: "expiry",
    //   headerName: "Expiry",
    //   editable: false,
    //   sortable: false,
    //   renderCell: ({ row }) => {
    //     return (
    //       <div className="user_block">
    //         <p>01/09/2025</p>
    //       </div>
    //     );
    //   },
    // },
    {
      flex: 0.4,
      minWidth: 100,
      field: "actions",

      headerName: "Actions",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <Button
              onClick={()=>navigate('/subscriptions/manage-subscriptions/edit/'+row?._id)}
              variant="outlined"
              color="inherit"
              size="small"
            >
              Edit
            </Button>
            <Button
              onClick={onCancel}
              variant="contained"
              sx={{
                background: "red",
                "&:hover": {
                  backgroundColor: "darkred", // set your desired hover color here
                },
              }}
              size="small"
            >
              Cancel
            </Button>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns}
          rows={rows}
          count={count}
          page={page}
          onPageChange={onPageChange}
          loading={loading}
        />
      </div>
    </>
  );
};

export default IndividualSubscriptions;
